import moment from "moment";

/**
 *
 * @param date
 * @returns a standard date or undefined if the input is not a valid date string
 */
export const getStandardISODate = (
  date?: Date | string,
  options?: { keepHours: boolean }
): string | undefined => {
  const keepHours = options?.keepHours ?? false;

  if (!date) return undefined;

  const d: moment.Moment = moment(date);

  if (!d.isValid()) return undefined;

  if (!keepHours) {
    d.startOf("day");
  }

  return d.utc(!keepHours).format("YYYY-MM-DDTHH:mm:ss[Z]");
};
